module.exports = __webpack_public_path__ + "img/upcommingEvents7.6827cc15.jpg";